import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, superadmin = false }) {
  const { user, checking } = useAuth();
  const loc = useLocation();
  if (checking) return <div className="p-6 text-muted-foreground mono">Checking session…</div>;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(loc.pathname)}`} replace />;
  if (superadmin && user.role !== "superadmin") return <Navigate to="/app" replace />;
  return children;
}
